import React from 'react';
import { render } from 'react-dom';
import 'regenerator-runtime/runtime';
import App from './App';

const appElement = document.querySelector('#app');

render(<App />, appElement);
